export const purpleColor = '#a100ff';
export const grayColor = '#5c5c5c';
export const CHAT_INPUT_ROW = 'chat-input-row';
export const FULL_PAGE_CHAT_PATH = '/app/growth-mentor';
export const CHAT_SUGGESTIONS_KEYWORD = ['Q1', 'Q2', 'Q3'];
export const MAX_LENGTH_SESSION_NAME = 20;
